<template>
  <div class="table-wrap">
    <h4>Criar Novo Voucher</h4>
    <FormNovoVoucher :scope="tipovoucher" v-if="tipovoucher" />
    <div class="botao">
    </div>
  </div>
</template>

<script>
import FormNovoVoucher from '@/components/financeiro/vouchers/form/NovoVoucher.vue'
import marketplaceService from '@/services/marketplace.service.js'

export default {
  components: { FormNovoVoucher },
  data() {
    return {
      tipovoucher: null,
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getTipoVoucher(this.$route.params.id)
    }
  },
  methods: {
    getTipoVoucher(idTipoVoucher) {
      marketplaceService.getTipoVoucher(idTipoVoucher)
        .then(response => {
          if (response.data.length > 0) {
            this.tipovoucher = response.data[0]
          }
        })
        .catch(error => {
          console.error('Erro ao buscar TipoVoucher:', error)
        })
    }
  }}
</script>

<style lang="scss" scoped>

.table-wrap {
    padding: $hmg $hmg_small $mg_extra;
  }

  .btn {
    margin-left: $mg_mini;
    margin-top: $hmg_mid;
  }

</style>>

